import React from "react";
import './selectContent.scss';
import SearchBar from "../../../../../shared/components/SearchBar";
import filterIcon from "../../../../../assets/icons/filter-icon.svg";
import {Checkbox} from "antd";
import pdfIcon from "../../../../../assets/icons/pdf-chapter-icon.svg";
import videoIcon from "../../../../../assets/icons/video-chapter-icon.svg";

const SelectContent = (props:any) => {

    const {handleSearch, contentList, selectedContents, setSelectedContents} = props;

    const handleContentSelection = (e:any,contentId:number) =>{
        if(e.target.checked){
            let selectedContent = contentList.filter((content:any) => content.id === contentId)
            setSelectedContents([...selectedContents,...selectedContent])
        }else{
            let filterContent = selectedContents.filter((content:any) => content.id !== contentId)
            setSelectedContents([...filterContent])
        }
    }

    return(
        <div>
            <div className="add-content__options">
                <div className='header-options__search add-content__search'>
                    <SearchBar handleSearch={handleSearch}/>
                </div>
                <div className='add-content__filter'>
                    <img src={filterIcon} alt=''/>
                </div>
            </div>
            <div className="add-content__selection">
                {contentList.map((content:any,i:number)=>
                    <div key={i}>
                        <div className="add-content__checkbox">
                            <Checkbox checked={
                                selectedContents.filter((obj:any) => obj.id===content.id).length > 0
                            }
                              onChange={(e)=>handleContentSelection(e,content.id)}
                              className='content__checkbox'
                            />
                        </div>
                        <div className="add-content__card">
                            <div className="add-content__card__image">
                                <img src={content?.displayPictureUrl} alt=''/>
                            </div>
                            <div className="add-content__info">
                                <div className="add-content__title">
                                    {content?.title}
                                </div>
                                <div className="add-content__detail">
                                    <img src={content?.contentType === 'pdf' ? pdfIcon : videoIcon} alt=''/>
                                    {content?.contentLength} {content?.contentType === 'pdf'? ' pages' : ' mins'}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default SelectContent;
